const mixinMutations = () => {
    return {
        setResponse(state, data) {
            state['response'] = data;
        },
        setList(state, data) {
            state[state.repositoryName] = data;
        },
        setStats(state, stats) {
            state.stats = stats;
        },
        setFilters(state, filters) {
            state.filters = filters;
        },
        setOptions(state, options) {
            state.options = options;
        },
        setRepositoryName(state, repositoryName) {
            return (state.repositoryName = repositoryName);
        },
        setIsShowExtraFilters(state, isShowExtraFilters) {
            state.isShowExtraFilters = isShowExtraFilters;
        },
    };
};

export default mixinMutations;
